import React, {FC} from "react";
import {
    Card,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {
    GarageDetailsAdditionalData,
    IGarageList,
} from "../../../interfaces/Interfaces";
import {GarageDetailsCardMobile} from "./GarageDetailsCardMobile";
import {GarageDetailsCardDesktop} from "./GarageDetailsCardDesktop";

interface Props {
    garage: IGarageList;
    details: GarageDetailsAdditionalData | null;
}

export const GarageDetailsCard: FC<Props> = ({garage, details}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Card
            sx={{

                padding: 2,
                boxShadow: 3,
                borderRadius: 2,
                mt: 2,
                maxWidth: "100%",
                backgroundColor: (theme) => theme.palette.card.background,
            }}
        >
            {isMobile ? (
                <GarageDetailsCardMobile garage={garage} details={details}/>
            ) : (
                <GarageDetailsCardDesktop garage={garage} details={details}/>
            )}
        </Card>
    );
};
